<template>
  <v-card>
    <v-card-title primary-title class="headline">
      Rete WiFi {{wlan0_on ? "ON" : "OFF"}}
      <v-spacer></v-spacer>
      <span>
        <v-switch v-model="wlan0_on"></v-switch>
      </span>
    </v-card-title>
    <v-slide-y-transition>
      <v-tabs icons-and-text dark grow v-if="wlan0_on">
        <v-tab>
          Status
          <v-icon>info</v-icon>
        </v-tab>
        <v-tab-item>
          <v-container fluid grid-list-md>
            <v-card>
              <v-card-title class="headline">{{$t('network-wlan0-status')}}</v-card-title>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>network_check</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{network.wlan0_ssid}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{$t('network-wlan0-current-connected')}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>extension</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{network.wlan0_current_address}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{$t('network-wlan0-current-address')}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <!--
                  <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>extension</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{network.wlan0_current_gateway}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{$t('network-wlan0-current-gateway')}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                -->
                  <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>dns</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{network.current_dns}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{$t('network-current-dns')}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-container>
        </v-tab-item>
        <v-tab>
          Settings
          <v-icon>settings</v-icon>
        </v-tab>
        <v-tab-item>
          <v-switch
            true-value="dhcp"
            false-value="static"
            v-model="network.wlan0_dhcp"
            label="DHCP"
          ></v-switch>

          <v-slide-y-transition>
            <div v-if="network.wlan0_dhcp == 'static'">
              <v-text-field v-model="network.wlan0_address" :label="$t('network-address')" required></v-text-field>
              <v-text-field v-model="network.wlan0_netmask" :label="$t('network-netmask')" required></v-text-field>
              <v-text-field v-model="network.wlan0_gateway" label="Gateway" required></v-text-field>
              <v-text-field v-model="network.wlan0_dns1" label="DNS" required></v-text-field>
              <v-text-field v-model="network.wlan0_dns2" label="DNS" required></v-text-field>
            </div>
          </v-slide-y-transition>
        </v-tab-item>
        <v-tab>
          WiFi List
          <v-icon>wifi</v-icon>
        </v-tab>
        <v-tab-item>
          <network-wifi-list></network-wifi-list>
        </v-tab-item>
      </v-tabs>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import NetworkWifiList from "@/components/NetworkWifiList.vue";

export default {
  name: "NetworkSettingsWlan0",
  data() {
    return {
    }
  },
  components: {
    NetworkWifiList
  },
  computed: {
    wlan0_on: {
      get: function() {
        return this.network.wlan0_power == "on";
      },
      set: function(value) {
        return (this.network.wlan0_power = value ? "on" : "off");
      }
    },
    ...mapGetters(["network"])
  }
};
</script>